import { RootState } from "@/store/store";
import { gridResourcesCurrentCleanDetailsSelector } from "@/store/resources-grid/selectors/clean/gridResourcesCurrentCleanDetailsSelector";
import { ResourceType } from "@/services/cloudchipr.api";

export const gridResourcesCurrentCleanResourceTypeSelector = (
  state: RootState,
): ResourceType | undefined => {
  const details = gridResourcesCurrentCleanDetailsSelector(state);

  return details?.resourceType;
};
